<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Ecommerce Application Development</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Ecommerce Application Development</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>B2B eCommerce Application Development</h3>
                    <p>A B2B e-commerce application is a business-to-business application.

                        This type of eCommerce app development aims to provide products between two businesses. And
                        businesses can increase
                        revenue by using B2B eCommerce applications. That is why B2B E-commerce application development
                        is a must for them.
                    </p>
                    <h3>B2C E commerce Apps Development</h3>
                    <p>B2C E-commerce is one of the most common application developments among web development services.
                        It represents most of
                        the versatile web applications that we use today.

                        It interfaces with a business offering an item or service to an individual buyer. The management
                        here is immediate with
                        the customer.</p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> B2C E commerce Apps Development</li>
                                    <li><i class="flaticon-check"></i> B2B eCommerce Application Development</li>
                                    <li><i class="flaticon-check"></i> C2C (Consumer -To- Consumer) eCommerce App
                                        Development</li>
                                    <li><i class="flaticon-check"></i> C2B (Consumer -to -Business) E-commerce
                                        Application Development</li>
                                    <li><i class="flaticon-check"></i> Ticketing & Booking E-commerce App Development
                                    </li>
                                    <li><i class="flaticon-check"></i> Auction/Bidding eCommerce Application Apps
                                        Development</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">Angular</a></li>
                        <li><a routerLink="/technology-expertise">Java</a></li>
                        <li><a routerLink="/technology-expertise">.Net</a></li>
                        <li><a routerLink="/technology-expertise">NodeJS</a></li>
                        <li><a routerLink="/technology-expertise">MSSQL</a></li>
                        <li><a routerLink="/technology-expertise">MySQL</a></li>
                        <li><a routerLink="/technology-expertise">Azure Devops</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/web-development-services">
                            <img src="assets/img/services/services-7.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/web-development-services">Web Application Development</a></h3>
                        <span>Using Java, .Net, Angular, NodeJS etc</span>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/automation-services">
                            <img src="assets/img/services/services-11.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/automation-services">Automation Services</a>
                        </h3>
                        <span>Using Automation tools</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/desktop-development-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/desktop-development-services">Desktop Application Development</a>
                        </h3>
                        <span>Using .Net, Java</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->